var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panorama"},[_c('i-aside'),_c('iframe',{attrs:{"id":"iframeContainer","src":_vm.link}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }